module.exports = __webpack_public_path__ + "static/media/img_feature_photo3@3x.e10566d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_feature_photo3@3x.png
// module id = 807
// module chunks = 0